import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { EmailNotificationSettings } from './email-notification-settings.model';

@Injectable({
  providedIn: 'root'
})
export class EmailNotificationSettingsService {
  constructor(private httpClient: HttpClient) {
  }

  getEmailNotificationSettingsData(id: string): Observable<EmailNotificationSettings> {
    const apiUrl = environment.api + `applications/email-notification-settings/${id}`;
    return this.httpClient.get<EmailNotificationSettings>(apiUrl)
      .pipe(catchError(() => of(this.getDefaultSettings(id))));
  }

  updateEmailNotificationSettingsData(id: string, data: EmailNotificationSettings): Observable<Response> {
    const apiUrl = environment.api + `applications/email-notification-settings/${id}`;
    const payload = { ...data, id };
    return this.httpClient.post<Response>(apiUrl, payload)
      .pipe(catchError(error => {
        if (error.status === 0 || error.status === 404) {
          return of(payload as any);
        }

        return throwError(error);
      }));
  }

  private getDefaultSettings(id = ''): EmailNotificationSettings {
    return {
      id,
      emails: [],
      notificationFrequency: 'OFF',
      notificationsToMonitor: {
        positive: false,
        negative: false
      }
    };
  }
}
